import React from 'react'
import Select from 'react-select'
import { KTSVG } from '_metronic/helpers'

interface Props {
  typeOptions: any[]
  filter: any
  onChangeFilter: (name: string, value: any) => void
  onClearFilter: () => void
  onSubmit: () => void
}

const Filter: React.FC<Props> = ({
  typeOptions,
  filter,
  onChangeFilter,
  onClearFilter,
  onSubmit,
}) => {
  return (
    <div
      id='kt_machine_filter'
      className='bg-body'
      data-kt-drawer='true'
      data-kt-drawer-name='chat'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'300px', 'md': '500px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_machine_filter_toggle'
      data-kt-drawer-close='#kt_machine_filter_close'>
      <div className='card w-100 rounded-0'>
        <div className='card-header pe-5'>
          <div className='card-title'>
            {/* begin:: Title */}
            <div className='d-flex justify-content-center flex-column me-3'>
              <span className='fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-2 lh-1'>
                ค้นหา
              </span>
            </div>
            {/* end:: Title */}
          </div>

          <div className='card-toolbar'>
            {/* begin:: Close Button */}
            <button
              className='btn btn-sm btn-bg-white btn-active-light-danger text-center'
              id='kt_machine_filter_close'>
              <KTSVG
                path='/media/icons/duotune/arrows/arr015.svg'
                className='svg-icon svg-icon-2x mx-auto'
              />
            </button>
            {/* end:: Close Button */}
          </div>
        </div>

        <div className='card-body'>
          <div
            data-kt-element='messages'
            data-kt-scroll='true'
            data-kt-scroll-activate='{default: false, lg: true}'
            data-kt-scroll-max-height='auto'
            data-kt-scroll-offset='5px'>
            <div className='row gy-5'>
              <div className='col-12'>
                <div className='fs-6 mb-3'>ชื่อเครื่องจักร</div>

                <input
                  type='text'
                  className='form-control form-control-sm'
                  placeholder=''
                  value={filter.q}
                  onChange={(e: any) => onChangeFilter('q', e.target.value)}
                  onKeyDown={(e: any) => {
                    if (e.key === 'Enter') {
                      onSubmit()
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore
                      document.querySelector('#kt_machine_filter_close')?.click()
                    }
                  }}
                />
              </div>

              <div className='col-12'>
                <div className='fs-6 mb-3'>ประเภทเครื่องจักร</div>

                <Select
                  styles={{
                    control: (provided: any, state: any) => ({
                      ...provided,
                      borderColor: '#e1e3ea',
                    }),
                  }}
                  options={typeOptions}
                  placeholder='ค้นหาด้วยประเภทเครื่องจักร'
                  value={typeOptions.find(s => s.value === filter.machineTypeID) ?? null}
                  onChange={(e: any) => onChangeFilter('machineTypeID', e?.value)}
                />
              </div>

              <div className='col-12 d-flex flex-row'>
                <button
                  className='btn btn-sm btn-primary me-4 w-50 fw-bold'
                  onClick={onSubmit}
                  id='kt_machine_filter_close'>
                  ค้นหา
                </button>
                <button
                  className='btn btn-sm btn-danger w-50 fw-bolder'
                  onClick={onClearFilter}
                  id='kt_machine_filter_close'>
                  ล้างค่า
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Filter
